// src/components/SimpleComponents/SimpleZip.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import SimpleInput from './SimpleInput';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
// Generic (US / international) postal code input. No country-specific mask and
// no external lookup API - plain text field. The provider handleAddressZipBlur
// only auto-searches for BR (CEP) and PT (Codigo Postal); other countries fill
// the address manually. Used by SimpleAddressZip as the fallback branch.
const SimpleZip = ({ name, subdocumentField, label = 'zip_code', ...props }) => {
  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <SimpleInput name={name} subdocumentField={subdocumentField} label={label} {...props} />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleZip;

// *******************************************************************************
// HELPERS
// *******************************************************************************
